/** Human-readable row label (matches OutputsAccountTable row headers). */
export function formatAccountRowLabel(key: string): string {
    return key.replace(/([A-Z])/g, ' $1').trim().replace(/^./, (c) => c.toUpperCase());
}

/** Row keys for the outputs account table and matching clipboard export order. */
export const accountRowOrder = [
    'baseUnits',
    'promoUnits',
    'grossRevenue',
    'overlay',
    'triggers',
    'netRevenue',
    'fixedSpend',
    'cogs',
    'logs',
    'grossProfit',
    'grossProfitPercent',
] as const;

export type AccountTableRowKey = (typeof accountRowOrder)[number];
